function n(t) {
  return (e) => (process.env.NODE_ENV === "development" && console.table({ [t]: e }), e);
}
export {
  n as t
};
//# sourceMappingURL=tap-CTCnk5YD.mjs.map
